import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientComponent } from './client/client.component';
import { GopherRoutingModule } from './gopher.routing.module';
import { LandingComponent } from './landing/landing.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { AttackComponent } from './attack/attack.component';
import { SharedModule } from '@app/_shared/shared.module';
import { ResultComponent } from './result/result.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { DetailsComponent } from './details/details.component';
import { NgChartjsModule } from 'ng-chartjs';
import { SharedPipeModule } from "../_pipes/shared-pipe.module";

@NgModule({
  declarations: [ClientComponent, LandingComponent, AttackComponent, ResultComponent, DetailsComponent],
  imports: [
    CommonModule,
    GopherRoutingModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ToastrModule,
    SharedModule,
    UiSwitchModule,
    NgChartjsModule,
    SharedPipeModule
]
})
export class GopherModule { }
